var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-numeric-text"},[_c('input',{ref:"input",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":function($event){_vm.updateValue($event.target.value);
      $event.target.blur();}}})])}
var staticRenderFns = []

export { render, staticRenderFns }